import React, { useMemo, useState } from 'react';
import PageShell, { SectionTitle } from './PageShell';
import { ChevronDown, Search, HelpCircle } from 'lucide-react';

const FAQ_DATA = [
  {
    cat: 'Plateforme',
    items: [
      {
        q: 'Code Voiture est-il vraiment gratuit ?',
        a: 'Oui, 100 % gratuit. Aucun abonnement, aucun « premium ». Nous ne vendons ni d\'inscription auto-école, ni de réservation d\'examen, ni de publicité. Le site est financé par le bénévolat d\'un collectif de moniteurs ECSR.',
      },
      {
        q: 'Faut-il créer un compte pour utiliser le site ?',
        a: 'Non. Tous les contenus publics (magazine, tutos, simulateurs, dossiers ETG, données ONISR) sont accessibles sans inscription. Le compte sert uniquement à tenir un livret d\'apprentissage numérique et à se lier à un enseignant ECSR.',
      },
      {
        q: 'Code Voiture remplace-t-il une auto-école ?',
        a: 'Non. La conduite pratique exige un enseignement présentiel par un moniteur titulaire du titre ECSR, sur un véhicule à double commandes. Code Voiture est un complément pédagogique théorique et conceptuel — pas un substitut à la formation pratique en auto-école agréée.',
      },
    ],
  },
  {
    cat: 'Examen du Code (ETG)',
    items: [
      {
        q: 'Où passer l\'examen du Code de la route ?',
        a: 'Auprès des opérateurs agréés par l\'État : La Poste, SGS, Bureau Veritas, Pearson Vue, Code\'n\'Go. Coût officiel : 30 € l\'épreuve. Inscription en ligne, examen sur tablette ou ordinateur dans un centre agréé.',
      },
      {
        q: 'Combien de fautes sont autorisées au Code ?',
        a: 'L\'examen comporte 40 questions. Pour réussir, il faut un minimum de 35 bonnes réponses (≤ 5 fautes). Chaque question dure 20 secondes maximum, sans retour en arrière possible.',
      },
      {
        q: 'Combien de temps le Code reste-t-il valable ?',
        a: 'L\'épreuve théorique générale (ETG) est valable 5 ans. Au cours de cette période, vous disposez de 5 tentatives à l\'examen pratique. Au-delà, il faut repasser le Code.',
      },
      {
        q: 'Quelle est la différence entre le Code rousseau, le Code en ligne, et Code Voiture ?',
        a: 'Le Code Rousseau et les plateformes type En Voiture Simone, Lepermislibre, etc. proposent des séries de QCM payantes pour s\'entraîner à l\'examen. Code Voiture propose une approche pédagogique magazine — moins centrée sur le bachotage, davantage sur la compréhension des situations.',
      },
    ],
  },
  {
    cat: 'Examen pratique',
    items: [
      {
        q: 'Quelles sont les conditions pour passer le permis B ?',
        a: 'Avoir 17 ans (l\'âge minimum de conduite seule est passé de 18 à 17 ans depuis le 01/01/2024, aussi bien en filière classique qu\'en AAC), être titulaire de l\'ASSR 2 (ou ASR pour les adultes), avoir réussi l\'ETG, avoir suivi 20 heures minimum de leçons de conduite en école agréée (13 h en BEA).',
      },
      {
        q: 'Que se passe-t-il si j\'échoue à l\'examen pratique ?',
        a: 'Vous pouvez vous représenter (généralement délai de 2 à 6 semaines selon les départements). Le test reste valable 5 ans après le Code. Au-delà de 5 échecs, il faut repasser le Code. L\'auto-école facture en général 30 à 60 € par représentation administrative.',
      },
      {
        q: 'Le permis voiture donne-t-il droit à conduire un scooter ?',
        a: 'Oui, sous conditions. Le permis B (obtenu avant le 01/03/1980) donne accès aux 125 cm³ automatiquement. Depuis, il faut détenir le permis B depuis au moins 2 ans ET avoir suivi une formation 125 (B96) de 7 heures dans une école agréée.',
      },
    ],
  },
  {
    cat: 'Permis probatoire & points',
    items: [
      {
        q: 'Comment fonctionne le permis probatoire ?',
        a: 'Tout nouveau conducteur démarre à 6 points (au lieu de 12). Le capital augmente automatiquement : +2 pts/an (filière classique, 3 ans) ou +3 pts/an (AAC, 2 ans) — à condition de ne perdre aucun point. La moindre infraction relance le compteur.',
      },
      {
        q: 'Combien de temps pour récupérer des points perdus ?',
        a: 'Hors probatoire : 6 mois sans infraction = +1 point automatique (pour une infraction à 1 pt) ; 2 ans sans infraction = retour à 12 pts. Stage volontaire de récupération : +4 pts max, une fois par an (≈ 240 €).',
      },
      {
        q: 'Que se passe-t-il à 0 point ?',
        a: 'Le permis est invalidé. Il faut attendre 6 mois (probatoire) à 1 an pour repasser le Code, puis l\'examen pratique. Une visite médicale et psychotechnique est obligatoire si l\'invalidation suit une suspension judiciaire.',
      },
    ],
  },
  {
    cat: 'Conduite accompagnée (AAC)',
    items: [
      {
        q: 'À partir de quel âge peut-on faire l\'AAC ?',
        a: 'Dès 15 ans (depuis 2014, contre 16 ans auparavant). L\'élève doit avoir réussi le Code et effectué les 20 heures minimum de conduite en école avant le début de la phase accompagnée.',
      },
      {
        q: 'Qui peut accompagner pendant la conduite supervisée ?',
        a: 'Un titulaire du permis B depuis au moins 5 ans sans interruption, qui doit être déclaré à l\'assurance et avoir reçu l\'accord de l\'auto-école (RDV pédagogique préalable).',
      },
      {
        q: 'Quels sont les avantages de l\'AAC ?',
        a: '+ 15 à 20 points de taux de réussite à l\'examen pratique en moyenne. Période probatoire réduite à 2 ans au lieu de 3. Tarif d\'assurance jeune conducteur souvent réduit. Expérience d\'au moins 3000 km validée avant l\'examen.',
      },
    ],
  },
  {
    cat: 'Enseignant ECSR',
    items: [
      {
        q: 'Comment activer un compte enseignant ?',
        a: 'À l\'inscription, sélectionnez « Enseignant ». Un email contenant votre numéro de titre ECSR et votre auto-école doit être envoyé à contact@codevoiture.fr. Validation manuelle sous 48 h ouvrées. Une fois activé, vous recevez votre code enseignant à 6 caractères.',
      },
      {
        q: 'Comment lier un élève à mon compte ?',
        a: 'Communiquez votre code enseignant à 6 caractères à votre élève. Il pourra le saisir dans son espace « Mon journal » → « Lier un enseignant ». À partir de là, vous accédez à son livret d\'apprentissage et pouvez valider ses compétences REMC.',
      },
      {
        q: 'Que contient le mode présentation pour les cours en salle ?',
        a: 'Une projection plein écran de la dernière analyse ONISR (baromètre mensuel des accidents), des grilles d\'évaluation pratique (31 points), des cas pratiques imprimables, et des QR codes pour que vos élèves accèdent à un dossier sur leur téléphone pendant le cours.',
      },
    ],
  },
];

export default function FAQPage() {
  const [query, setQuery] = useState('');
  const [openId, setOpenId] = useState(null);

  const filtered = useMemo(() => {
    if (!query.trim()) return FAQ_DATA;
    const q = query.toLowerCase();
    return FAQ_DATA
      .map((cat) => ({
        ...cat,
        items: cat.items.filter((it) => it.q.toLowerCase().includes(q) || it.a.toLowerCase().includes(q)),
      }))
      .filter((cat) => cat.items.length > 0);
  }, [query]);

  const total = FAQ_DATA.reduce((acc, c) => acc + c.items.length, 0);

  return (
    <PageShell>
      <section className="max-w-5xl mx-auto px-4 lg:px-6 mt-8 sm:mt-12">
        <SectionTitle
          kicker="Foire aux questions · Code Voiture"
          title={`${total} réponses · clair, précis, sourcé`}
          sub="Les questions le plus souvent posées sur le permis voiture, l'examen, la plateforme et le suivi pédagogique."
        />

        {/* Search */}
        <div className="relative mb-7 sm:mb-10">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" size={17} />
          <input
            data-testid="faq-search"
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Rechercher dans la FAQ…"
            className="w-full h-11 sm:h-12 pl-12 pr-4 rounded-xl sm:rounded-2xl bg-[#0d0d0e] border border-white/10 text-white text-[13.5px] sm:text-[14px] outline-none focus:border-red-500 transition"
          />
        </div>

        {filtered.length === 0 ? (
          <div className="text-white/50 py-12 sm:py-16 text-center">
            <HelpCircle className="mx-auto mb-3 text-white/30" size={32} />
            Aucune réponse pour « {query} ». Écrivez-nous à <a className="text-red-400 hover:text-red-300" href="mailto:contact@codevoiture.fr">contact@codevoiture.fr</a>.
          </div>
        ) : (
          <div className="space-y-7 sm:space-y-10">
            {filtered.map((cat) => (
              <div key={cat.cat}>
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-red-400 font-bold mb-3 sm:mb-4 font-mono-spec">{cat.cat}</div>
                <div className="space-y-2 sm:space-y-2.5">
                  {cat.items.map((it, idx) => {
                    const id = `${cat.cat}-${idx}`;
                    const open = openId === id;
                    return (
                      <div
                        key={id}
                        className={`rounded-xl sm:rounded-2xl border transition ${open ? 'border-red-700/40 bg-[#131215]' : 'border-white/10 bg-[#0d0d0e] hover:border-white/20'}`}
                      >
                        <button
                          data-testid={`faq-item-${cat.cat.toLowerCase().replace(/\s/g, '-')}-${idx}`}
                          onClick={() => setOpenId(open ? null : id)}
                          className="w-full text-left p-4 sm:p-5 lg:p-6 flex items-start justify-between gap-3 sm:gap-4"
                        >
                          <span className="font-serif-editorial text-white text-[15px] sm:text-[18px] lg:text-[20px] leading-tight">{it.q}</span>
                          <ChevronDown size={18} className={`text-white/50 shrink-0 mt-1 transition-transform ${open ? 'rotate-180 text-red-400' : ''}`} />
                        </button>
                        {open && (
                          <div className="px-4 pb-4 sm:px-5 sm:pb-5 lg:px-6 lg:pb-6 -mt-1 text-white/75 text-[13px] sm:text-[14.5px] leading-relaxed border-t border-white/5 pt-3 sm:pt-4">
                            {it.a}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-10 sm:mt-16 rounded-xl sm:rounded-2xl border border-white/10 bg-[#0d0d0e] p-5 sm:p-7 text-center">
          <div className="text-white text-[14.5px] sm:text-[16px] font-semibold mb-1">Vous ne trouvez pas votre réponse ?</div>
          <p className="text-white/60 text-[12.5px] sm:text-[13.5px] mb-4">Nous répondons sous 48 h ouvrées.</p>
          <a data-testid="faq-contact-btn" href="mailto:contact@codevoiture.fr?subject=Question%20FAQ%20codevoiture.fr" className="inline-flex items-center gap-2 h-10 sm:h-11 px-4 sm:px-5 rounded-full bg-red-600 hover:bg-red-500 text-white text-[12.5px] sm:text-[13.5px] font-semibold">
            Poser ma question
          </a>
        </div>
      </section>
    </PageShell>
  );
}
